import * as React from 'react';
import { Box, Card } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { createSvgIcon } from '@mui/material';
import { useAppSelector} from '../../hooks'
import CanchasMap from './components/map/mapContent';
import { Status} from '@googlemaps/react-wrapper';
import FacturacionUser from './components/bills/BillsContent'
import HotelesUser from './components/benefits/HotelContent'
import MarcasUser from './components/benefits/ShopContent'
import MisPuntosUser from './components/benefits/RewardsContent'
import { black } from '../../getLPTheme';
import UserCredentialContainer from './components/credential/credentialContent'
import SlackUser from './components/slack/Slack';
import LandingUser from './components/landing/LandingContent'
import UserDetailContainer from './components/profile/profileContainer'
import NotificationsContainer from './components/notifications/notificationContainer'

const theme = createTheme({
  palette: {
    primary: {
      main: '#7c7c7c',
      light: '#969696',
      dark: '#565656',
      contrastText: '#242105',
    },
    secondary: {
      main: '#bababa',
      light: '#bababa',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#bababa',
    },
  },
});


const render = (status: Status) => (<h1>{status}</h1>)

function MenuSelected() {
  let navigatorSelect = useAppSelector(state => state.navigator.value)

  if(navigatorSelect == 'Notificaciones'){
    // return <NotificacionesUser/>;
    return <NotificationsContainer/>;

  }
  else if (navigatorSelect == 'Editar Perfil') {
    return <UserDetailContainer/>;
  }
  else if (navigatorSelect == 'Suscripción') {
    return <FacturacionUser/>;
  }
  else if (navigatorSelect == 'Mis Puntos') {
    return <MisPuntosUser/>;
  }
  else if (navigatorSelect == 'Mi Credencial') {
    return <UserCredentialContainer/>;
  }
  else if (navigatorSelect == 'Slack') {
    return <SlackUser/>;
  }
  else if (navigatorSelect == 'Mapa') {
    return <CanchasMap/>
  }
  else if (navigatorSelect == 'Hoteles') {
    return <HotelesUser/>;
  }
  else if (navigatorSelect == 'Marcas') {
    return <MarcasUser/>;
  }
  // else if (navigatorSelect == 'Cotizá tu viaje') {
  //   return <VuelosUser/>;
  // }  
  else  {
    return <LandingUser/>
  }          
}

export default function ContentUser() { 

const navigatorSelect = useAppSelector(state => state.navigator.value)


  return (
    <ThemeProvider theme={theme}>
      <Card sx={{ width: '100%'}}>
        <Box sx={{backgroundColor: black[1000], position: 'relative', paddingBottom: 2}}>
          <MenuSelected/>
        </Box>
      </Card>
    </ThemeProvider>
  );
}
